/*global _ */
import contextProps from '../../../../../../props/context'
const localProps = {
  translations: {},
  settings: {},

  products: {},
  value: {},

  classes: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('classes', null)
    }
  },
  contentComponents: {
    type: [Array, Object],
    default() {
      return _.merge(
        {},
        this.$options.$$t('contentComponents', {}),
        this.$options.$$s('contentComponents', {})
      )
    }
  },

  header: {
    default() {
      const values = _.merge(
        {},
        this.$options.$$t('header', {}),
        this.$options.$$s('header', {})
      )
      if (_.isEmpty(values)) {
        return {
          'title': 'Product name',
          'quantity': 'Quantity',
          'price': 'Price',
          'subTotal': 'Sub total',
          'tax': 'Tax',
          'total': 'Total',
        }
      }
      return values
    }
  },
  columns: {
    default() {
      return _.merge(
        {},
        this.$options.$$t('columns', {}),
        this.$options.$$s('columns', {})
      )
    }
  },
  columnsOrder: {
    default() {
      this.$options.$$s('columnsOrder')
    }
  },
  footer: {
    default() {
      const values = _.merge(
        {},
        this.$options.$$t('footer', {}),
        this.$options.$$s('footer', {})
      )
      if (_.isEmpty(values)) {
        return {
          'subTotal': {},
          'tax': {},
          'total': {},
        }
      }
      return values
    }
  },
  footerOrder: {
    default() {
      this.$options.$$s('footerOrder')
    }
  },
  containerClasses: {
    default() {
      return this.$options.$$s('containerClasses', [])
    }
  },
  summaryContainerClasses: {
    default() {
      return this.$options.$$s('summary.container.classes', [])
    }
  },
  summaryHeaderClasses: {
    default() {
      return this.$options.$$s('summary.header.classes', [])
    }
  },
  summaryLinesClasses: {
    default() {
      return this.$options.$$s('summary.lines.classes', [])
    }
  },
  summaryLineClasses: {
    default() {
      return this.$options.$$s('summary.line.classes', [])
    }
  },
  summaryFooterClasses: {
    default() {
      return this.$options.$$s('summary.footer.classes', [])
    }
  },
}
export const props = {
  ...contextProps,
  ...localProps
}
export default props
